import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { IFilterSection } from "@faire/web-api--source/indigofair/data/IFilterSection";
import { buildFilterKey, SORT_FILTER_TYPE } from "./filterKeys";
export var getSort = function(filterSections) {
    return filterSections.find(function(filterSection) {
        return filterSection.field_function === IFilterSection.FieldFunction.SORT;
    });
};
export function getFilterOptions(sections) {
    return sections.reduce(function(acc, section) {
        if (section.options) {
            acc = acc.concat(getFilterOptionsRecursively(section.options));
        }
        return acc;
    }, []);
}
function getFilterOptionsRecursively(options) {
    var result = options;
    options.forEach(function(option) {
        var _option_sub_options;
        if ((_option_sub_options = option.sub_options) === null || _option_sub_options === void 0 ? void 0 : _option_sub_options.length) {
            result = result.concat(getFilterOptionsRecursively(option.sub_options));
        }
    });
    return result;
}
function getSelectedFilterKeysFromOptions(filterOptions) {
    var defaultSortKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : buildFilterKey(SORT_FILTER_TYPE, "featured");
    return _to_consumable_array(new Set(filterOptions.map(function(option) {
        return option.key !== defaultSortKey && option.is_selected ? option.key : "";
    }).filter(function(filterKey) {
        return !!filterKey;
    })));
}
export function getSelectedFilterKeys(filterSections) {
    var sortSection = getSort(filterSections);
    var defaultSortKey = sortSection === null || sortSection === void 0 ? void 0 : sortSection.default_option_key;
    var filterOptions = getFilterOptions(filterSections);
    return getSelectedFilterKeysFromOptions(filterOptions, defaultSortKey);
}
